import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'weblisting-rating-stars',
  templateUrl: './weblisting-rating-stars.component.html',
  styleUrls: ['./weblisting-rating-stars.component.scss'],
  standalone: false,
})
export class WeblistingRatingStarsComponent implements OnChanges {
  @Input() rating: number;
  @Input() nStars: number;

  filledStarsArray = [];
  unfiledStarsArray = [];

  ngOnChanges(): void {
    this.calculateFilledStars();
  }

  calculateFilledStars(): void {
    const nStars = this.nStars ? this.nStars : 5;
    const rating = this.rating ? this.rating : 0;
    const unfilledStars = nStars - rating;
    this.filledStarsArray = new Array(rating);
    this.unfiledStarsArray = new Array(unfilledStars);
  }
}
